import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import { Cross, Trash } from '../../../../components/ui/Icons';

export default function CurrentRefinements({
  currentRefinements,
  clearRefinements,
  additionalData,
}: componentTypes.CurrentRefinementsProps) {
  const {
    items, refine,
  } = currentRefinements;

  const { catalog } = additionalData;

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="py-4 p-46 lg:py-8 lg:border-t lg:border-near-black/10">
      <div className="overflow-x-auto lg:overflow-x-hidden overflow-y-hidden px-4 md:px-6 lg:px-0 pb-2.5 -mx-4 md:-mx-6 lg:mx-0 -mb-2.5 flex lg:flex-wrap gap-4">
        {items.map((item) => (
          <div key={item.label} className="*:inline-flex *:items-center *:gap-x-3 *:text-sm *:leading-none *:font-semibold *:rounded *:border *:border-near-black/10 *:py-2.5 *:px-3 *:transition-all *:whitespace-nowrap">
            {item.refinements.map((refinement) => (
              <button
                key={refinement.value}
                type="button"
                className="group hover:border-near-black"
                onClick={() => refine(refinement)}
              >
                {item.attribute === 'onPromotion' ? Craft.t(catalog, 'Sale products') : refinement.label}
                <Cross className="w-3 transition-colors group-hover:text-accent" />
              </button>
            ))}
          </div>
        ))}
        {clearRefinements.canRefine && (
          <div className="*:inline-flex *:items-center *:gap-x-3 *:text-sm *:leading-none *:font-semibold *:rounded *:border *:border-near-black/10 *:py-2.5 *:px-3 *:transition-all *:whitespace-nowrap">
            <button
              type="button"
              className="group hover:border-near-black"
              onClick={() => clearRefinements.refine()}
            >
              {Craft.t(catalog, 'Verwijder alles')}
              <Trash className="w-3 transition-colors group-hover:text-accent" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
